import { apiRegistry } from '../../../common/infra/apiRegistry'
import { filesMem } from '../mem/filesMem'

apiRegistry.registerPostApi('renameFile', async (request) => {
  const { fileId, newName } = request

  const file = filesMem[fileId]
  if (!file) {
    throw new Error('File not found')
  }

  // Check for name conflicts in the same folder
  const siblingFiles = Object.values(filesMem).filter(f => f.parentId === file.parentId && f.id !== fileId)
  if (siblingFiles.some(f => f.name === newName)) {
    throw new Error('A file with this name already exists')
  }

  const oldPath = file.path
  const parentPath = file.parentId ? filesMem[file.parentId].path : ''
  const newPath = `${parentPath}/${newName}`

  // Update file properties
  file.name = newName
  file.path = newPath
  file.modifiedDate = new Date().toISOString()

  // Update extension for files
  if (file.type === 'file') {
    file.extension = newName.split('.').pop()?.toLowerCase() || ''
  }

  // If it's a folder, update all children paths
  if (file.type === 'folder') {
    const children = Object.values(filesMem).filter(f => f.path.startsWith(oldPath + '/'))
    for (const child of children) {
      child.path = child.path.replace(oldPath, newPath)
    }
  }

  return { file }
})